import * as React from 'react';

const HorizontalBarsIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={10}>
    <path
      fill={fillColor}
      d="M6.958 10a.603.603 0 0 1-.445-.18.61.61 0 0 1-.18-.449.61.61 0 0 1 .625-.621h2.084c.177 0 .325.06.445.18.12.121.18.27.18.449a.61.61 0 0 1-.625.621H6.958ZM1.125 1.25a.603.603 0 0 1-.445-.18A.61.61 0 0 1 .5.62.61.61 0 0 1 1.125 0h13.75c.177 0 .325.06.445.18.12.121.18.27.18.449a.61.61 0 0 1-.625.621H1.125Zm2.5 4.375a.603.603 0 0 1-.445-.18.61.61 0 0 1-.18-.449.61.61 0 0 1 .625-.621h8.75c.177 0 .325.06.445.18.12.121.18.27.18.449a.61.61 0 0 1-.625.621h-8.75Z"
    />
  </svg>
);

export default HorizontalBarsIcon;
